import { Submit } from './gb-submit';
riot.tag2('gb-submit', '<yield> <a class="gb-submit {_style}">&#128269;</a> </yield>', 'gb-submit .gb-stylish.gb-submit,[riot-tag="gb-submit"] .gb-stylish.gb-submit,[data-is="gb-submit"] .gb-stylish.gb-submit{ padding: 4px; } gb-submit .gb-stylish.gb-submit:hover,[riot-tag="gb-submit"] .gb-stylish.gb-submit:hover,[data-is="gb-submit"] .gb-stylish.gb-submit:hover{ cursor: pointer; }', '', function(opts) {
    this._mixin(Submit);
});



/** WEBPACK FOOTER **
 ** ./src/tags/submit/gb-submit.tag.html
 **/